import { ReactionsType } from 'shared_DEPRECATED/components/Reactions/types';

import {
  useCreateChatMessageReaction,
  useDeleteChatMessageReaction,
} from 'features/chat/hooks';
import { User } from 'features/user/User';

import { ChatMessageReactionsView } from './ChatMessageReactionsView';

type ChatMessageReactionsProps = {
  chatId: string;
  messageId: string;
  reactions: ReactionsType;
  user: User;
  emojiPickerPosition?: 'start' | 'end';
};

export const ChatMessageReactions = ({
  chatId,
  messageId,
  reactions,
  user,
  emojiPickerPosition = 'end',
}: ChatMessageReactionsProps) => {
  const { mutateAsync: addReaction } = useCreateChatMessageReaction({
    chatId,
    user,
  });

  const { mutateAsync: removeReaction } = useDeleteChatMessageReaction({
    chatId,
    user,
  });

  const handleAddReaction = async (reaction: string) => {
    await addReaction({ messageId, reaction });
  };

  const handleRemoveReaction = async (reaction: string) => {
    await removeReaction({ messageId, reaction });
  };

  return (
    <ChatMessageReactionsView
      reactions={reactions}
      onAddReaction={handleAddReaction}
      onRemoveReaction={handleRemoveReaction}
      user={user}
      emojiPickerPosition={emojiPickerPosition}
    />
  );
};
